import Layout from '../modules/Layout';
import OpenDataAppIntegration from '../modules/OpenData/OpenDataAppIntegration';
import { OPEN_DATA_PAGE_QUERY } from '../modules/OpenData/graphql';
import { openDataQuery } from '../core-types';
import { CustomNextPage } from '../lib/types';
import { bootstrap } from '../lib/bootstrap';
import { useQuery } from '@apollo/client';

const OpenDataAppPage: CustomNextPage<{
  statusCode?: number;
}> = props => {
  const { url, statusCode } = props;
  const { loading, data } = useQuery<openDataQuery>(OPEN_DATA_PAGE_QUERY);
  const title = data && data.openData && data.openData.appIntegrationTitle;

  return (
    <Layout
      statusCode={statusCode}
      title={title}
      url={url}
      loading={loading}
      contentProps={{
        py: 0,
        mx: 0,
        mb: 0
      }}
      render={() => {
        if (!data || !data.openData) {
          return null;
        }
        return <OpenDataAppIntegration data={data} />;
      }}
    />
  );
};

OpenDataAppPage.getInitialProps = async ctx => {
  const openDataPageResult = await ctx.apolloClient.query<openDataQuery>({
    query: OPEN_DATA_PAGE_QUERY
  });

  const { data } = openDataPageResult;
  let showAppIntegration = false;

  if (data && data.system) {
    showAppIntegration = Boolean(data.system.appDeepLinkingPrefix);
  }

  let statusCode;
  if (!openDataPageResult.data?.openData || !showAppIntegration) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return {
    statusCode
  };
};

export default bootstrap(OpenDataAppPage);
